import React from "react";
import { CheckCircle, XCircle, ArrowRight } from "lucide-react";

export default function PaymentStatusChamba({ success, finalAmount, paymentID, formData }) {
  const amountPaid = finalAmount || "0";
  const paymentId = paymentID || "N/A";

  return (
  <div
  className="
    w-full 
    flex 
    flex-col 
    items-center 
    bg-gradient-to-br 
    from-gray-50 
    to-blue-50 
    overflow-y-auto 
    px-4  
  "
  style={{
    minHeight: "100dvh",
    WebkitOverflowScrolling: "touch",
  }}
>
  <div className="w-full max-w-3xl bg-white/70 backdrop-blur-sm p-8 text-center border border-gray-100 rounded-xl shadow-sm mb-8">
        {/* Status Header */}
        <div className="mb-6 flex flex-col items-center mt-4">
          {success ? (
            <CheckCircle
              size={80}
              className="text-green mb-3 drop-shadow-md"
            />
          ) : (
            <XCircle
              size={80}
              className="text-red-500 mb-3 animate-pulse drop-shadow-md"
            />
          )}

          <h1
            className={`text-3xl font-bold ${
              success ? "text-green-700" : "text-red-600"
            }`}
          >
            {success ? "Registration Successful!" : "Registration Failed"}
          </h1>
          <p className="text-gray-600 mt-2 text-base">
            {success
              ? "Thank you for registering for MTB Chamba 2025."
              : "Something went wrong with your payment. Please try again later."}
          </p>
        </div>

        {/* Payment Summary */}
        <div className="w-full bg-gray-50 border border-gray-200 rounded-xl shadow-sm p-6 text-left mb-8">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Payment Summary
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-gray-700">
            <p>
              <span className="font-medium text-gray-900">Status:</span>{" "}
              {success ? (
                <span className="text-green font-semibold">PAID</span>
              ) : (
                <span className="text-red-600 font-semibold">FAILED</span>
              )}
            </p>
            <p>
              <span className="font-medium text-gray-900">Amount Paid:</span> ₹
              {amountPaid}
            </p>
            <p className="sm:col-span-2">
              <span className="font-medium text-gray-900">Transaction ID:</span>{" "}
              {paymentId}
            </p>
          </div>
        </div>

        {/* Participant Details */}
        {formData && (
          <div className="w-full bg-gray-50 border border-gray-200 rounded-xl shadow-sm p-6 text-left mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Participant Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6 text-gray-700">
              {[
                { label: "Full Name", value: formData.name },
                { label: "Age", value: formData.age },
                { label: "Date of Birth", value: formData.dob },
                { label: "Contact", value: formData.primaryContact },
                { label: "Emergency Contact", value: formData.emergencyContact },
                { label: "Category", value: formData.race_category },
                { label: "T-shirt Size", value: formData.tshirtSize },
                { label: "City", value: formData.city },
                { label: "State", value: formData.state },
                { label: "Experience", value: formData.cycling_experience, full: true },
              ].map((item, idx) => (
                <p
                  key={idx}
                  className={`${
                    item.full ? "sm:col-span-2" : ""
                  } border-b border-gray-100 pb-1`}
                >
                  <span className="font-medium text-gray-900">{item.label}:</span>{" "}
                  {item.value && item.value.trim() !== "" ? item.value : "—"}
                </p>
              ))}
            </div>
          </div>
        )}

        {/* Organizer Link */}
        <div className="text-gray-700 text-base">
          Visit{" "}
          <a
            href="https://cyclecircle.one"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue font-semibold hover:underline inline-flex items-center gap-1"
          >
            CycleCircle.one <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </div>
  );
}
